import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "./Products.css";

const cards = [
  {
    slug: "homes",
    title: "Homes",
    desc: "Luxury living spaces designed with emotion and precision.",
    image: "/img/products/homes.png",
  },
  {
    slug: "experience-center",
    title: "Experience Center",
    desc: "Immersive brand storytelling environments.",
    image: "/img/products/Experince.png",
  },
  {
    slug: "offices",
    title: "Offices",
    desc: "Performance driven workspaces.",
    image: "/img/products/office.jpg",
  },
  {
    slug: "sample",
    title: "Sample Apartments",
    desc: "Experience spaces before they exist.",
    image: "/img/products/samap.png",
  },
];

/* FIXED TRIANGLE LAYOUT */
const positions = [
  { x: -210, y: 0, scale: 1, z: 5 },
  { x: 210, y: 0, scale: 1, z: 5 },
  { x: -600, y: 0, scale: 0.9, z: 4 },
  { x: 600, y: 0, scale: 0.9, z: 4 },
];
export default function Products() {
  const [rotation, setRotation] = useState(0);
  const [paused, setPaused] = useState(false);

  // scroll to top when page opens
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* content switching only */
  useEffect(() => {
    if (paused) return;

    const id = setInterval(() => {
      setRotation(r => (r + 1) % cards.length);
    }, 2600);

    return () => clearInterval(id);
  }, [paused]);



  return (
    <>
      <Navbar />

      <div className="stage">
        <video className="stage-video" autoPlay muted loop playsInline>
          <source src="/p1.mp4" type="video/mp4" />
        </video>

        <div className="orbit-scene">

          {positions.map((pos, i) => {

            const content = cards[(i + rotation) % cards.length];

            return (
              <Link
                key={i}
                to={`/products/${content.slug}`}
                className="orbit-card premium"
                
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                style={{
                  transform: `
                    translate(-50%, -50%)
                    translate(${pos.x}px, ${pos.y}px)
                    scale(${pos.scale})
                  `,
                  zIndex: pos.z
                }}
                
              >
                <div className="img-wrap">
                  <img src={content.image} alt={content.title} />
                </div>

                <div className="overlay">
                  <h3>{content.title}</h3>
                  <p>{content.desc}</p>
                </div>
                <div className="click-hint">
  Click to explore
</div>
              </Link>
            );
          })}

        </div>
      </div>

      <Footer />
    </>
  );
}